import { render, staticRenderFns } from "./LoadingZone.vue?vue&type=template&id=122cebf7&scoped=true&"
import script from "./LoadingZone.vue?vue&type=script&lang=js&"
export * from "./LoadingZone.vue?vue&type=script&lang=js&"
import style0 from "./LoadingZone.vue?vue&type=style&index=0&id=122cebf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122cebf7",
  null
  
)

export default component.exports